<form [formGroup]="toolsFormGroup">
    <app-nearest-obstruction [form]="toolsFormGroup"></app-nearest-obstruction>

    <app-tool [form]="toolsFormGroup" [tools]="tools"></app-tool>
</form>
